import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { fetchInterceptors } from "../../Api/fetchInterceptors";

const END_POINT = process.env.REACT_APP_DB_LIST;

export const fetchUserDbList = createAsyncThunk(
  "auth/user-db/list",
  async (_, thunkAPI) => {
    try {
      // const response = axiosInterceptors("/user/profile");
      const response = fetchInterceptors(END_POINT, "GET");

      return response;
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const dbListSlice = createSlice({
  name: "auth/user-db/list",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    error: null,
    loading: false,
  },
  reducers: {
    setDefaultDbListState: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.error = null;
      state.loading = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDbList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserDbList.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.error = null;
          state.response = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        } else {
          state.response = null;
          state.error = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        }
      })
      .addCase(fetchUserDbList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setDefaultDbListState } = dbListSlice.actions;

export default dbListSlice.reducer;
